import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SLIButton, SLIButtonStyle } from '../buttons/SLIButton';
import { ROUTES } from '../../constants/routes';
import { getEquipmentTranslation } from '../../utils/equipmentTranslation';

const FarmshareEquipmentCard = ({ equipment }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleClick = () => {
    navigate(ROUTES.DETAIL_EQUIPMENT.replace(':equipmentId', equipment._id));
  };

  const equipmentName = getEquipmentTranslation(equipment, 'name', currentLang);
  const equipmentDescription = getEquipmentTranslation(equipment, 'description', currentLang);

  return (
    <div className="sli-card w-full">
      <img
        src={equipment.images[0]}
        alt={equipmentName}
        className="w-full h-[244px] object-cover rounded-lg"
      />
      <span className="text-2xl font-medium truncate">{equipmentName}</span>
      <span className="text-sm font-semibold text-SLIGreen">{equipment.location}</span>
      <span className="text-gray-500 mt-6 mb-16">{equipmentDescription}</span>
      <div className="flex items-center justify-between mt-auto">
        <span className="text-2xl">${equipment.rentalPrice}/Day</span>
        <SLIButton
          label="View"
          buttonStyle={SLIButtonStyle.LIGHT}
          onClick={handleClick}
          className="px-10"
        />
      </div>
    </div>
  );
};

export { FarmshareEquipmentCard };
